"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccountBalanceDialog = useAccountBalanceDialog;
var _culture = require("@ori/culture");
var _shoppingContext = require("@ori/shopping-context");
var _api = require("../../api");
var _hooks = require("../../hooks");
function useAccountBalanceDialog() {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    culture,
    timeZone
  } = (0, _culture.useCulture)();
  const {
    isLoaded,
    shoppingContext: {
      shoppingBag: {
        balanceBefore: {
          credit = '',
          discount = '',
          groupBp = '',
          personalBp = ''
        } = {},
        isAccountBalanceVisible
      } = {},
      showBp
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    currentPeriod,
    isCurrentPeriodLoading
  } = (0, _api.useGetCurrentPeriod)({
    isActive: Boolean(personalBp || groupBp)
  });
  const periodCode = currentPeriod?.period?.periodCode;
  const validTo = currentPeriod?.period?.valid?.to;
  const validToFormatted = validTo instanceof Date ? (0, _culture.formatDate)(validTo, _culture.DateFormat.ShortDate, culture, timeZone) : '';
  const periodNumber = periodCode == null ? '' : periodCode.toString().slice(-2);
  const balanceSections = [];
  if (!isLoaded || isCurrentPeriodLoading) {
    return [];
  }
  if (credit) {
    balanceSections.push({
      title: formatMessage('credit'),
      lines: [{
        label: formatMessage('availableToUseNow'),
        value: credit
      }]
    });
  }
  if (isAccountBalanceVisible && discount) {
    balanceSections.push({
      title: formatMessage('wallet'),
      description: formatMessage('walletIsAutoAppliedAndCanCoverUpToXOfYourOrder'),
      lines: [{
        label: formatMessage('availableToUseNow'),
        value: discount
      }]
    });
  }
  if (showBp && (personalBp || groupBp)) {
    const bpLines = [];
    if (personalBp) {
      bpLines.push({
        label: formatMessage('personal'),
        value: `${personalBp} ${formatMessage('bp')}`
      });
    }
    if (groupBp) {
      bpLines.push({
        label: formatMessage('group'),
        value: `${groupBp} ${formatMessage('bp')}`
      });
    }
    balanceSections.push({
      title: formatMessage('bonusPoints'),
      description: formatMessage('bonusPointsFromPlacedOrdersInCampaign', {
        0: periodNumber,
        1: validToFormatted
      }),
      lines: bpLines
    });
  }
  return balanceSections;
}